var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"js-loading",attrs:{"text":"没有更多数据了"}},[_c('p'),_c('div',{staticClass:"js-loadMoreBtn pointer",on:{"click":_vm.more}},[_c('span',[_vm._v(" 加载更多信息 ")])]),_c('p')])])
}
var staticRenderFns = []

export { render, staticRenderFns }